module.exports = __webpack_public_path__ + "img/mainB02.466bb419.jpeg";